import React, { Component } from "react";
import { NavBar, SideBar, Footer } from "../../components";
import "react-toastify/dist/ReactToastify.css";
import PouchDB from "pouchdb";
import PouchdbFind from "pouchdb-find";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { cepMask } from "../../mask";
import axios from "axios";
import clienteModel from "../../models/cliente";
import agendaModel from "../../models/agenda";
import usuarioModel from "../../models/usuario";
import queryString from "query-string";
import moment from "moment";
import AsyncSelect from "react-select/async";
import Select from "react-select";
import Switch from "react-switch";
import DatePicker from "react-datepicker";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  UncontrolledTooltip,
} from "reactstrap";
PouchDB.plugin(PouchdbFind);

export default class Usuario extends Component {
  constructor(props) {
    super(props);
    this.load = this.load.bind(this);
    this.loadUsuarios = this.loadUsuarios.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
    this.mensagemSucesso = this.mensagemSucesso.bind(this);
    this.notificar = this.notificar.bind(this);
    this.onChangePagina = this.onChangePagina.bind(this);
    this.handleClickDeletar = this.handleClickDeletar.bind(this);
    this.toggleModalDeslogar = this.toggleModalDeslogar.bind(this);
    this.handleClickDeslogar = this.handleClickDeslogar.bind(this);
    this.handleConfirmDeslogar = this.handleConfirmDeslogar.bind(this);
    this.abrirPaginaEditar = this.abrirPaginaEditar.bind(this);

    this.state = {
      licencas: [],
      modal: false,
      idSelecionado: null,
      paginacao: {
        pagina: 1,
        limite: 15,
        totalItens: 0,
      },
      usuarios: [],
      habilitaNovosUsuarios: false,
      modalDeslogar: false,
      idUsuarioDeslogar: null,
      totalLicencas: 0,
      totalLicencasUtilizadas: 0,
    };
  }

  async componentDidMount() {
    await this.load();
  }

  async load() {
    await this.loadUsuarios();
  }

  async loadUsuarios() {
    await axios
      .get(
        `${this.props.getBaseUrlApi()}/usuarios/lista`,
        this.props.parameters()
      )
      .then((response) => {
        this.setState({
          usuarios: response.data.usuarios,
          habilitaNovosUsuarios: response.data.habilitaNovosUsuarios,
          totalLicencas: response.data.totalLicencas,
          totalLicencasUtilizadas: response.data.totalLicencasUtilizadas,
        });
      })
      .catch((error) => {
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status === 401) {
            this.props.logout();
          }
          if (error.response.status === 403) {
            this.props.history.push("/home");
          }
        }
      });
  }

  toggleModal() {
    this.setState((prevState) => {
      return { modal: !prevState.modal };
    });
  }

  mensagemSucesso(message) {
    toast.success(message, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  }

  notificar(type, message) {
    toast[type](message, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  }

  onChangePagina(pagina) {
    this.setState(
      { paginacao: { ...this.state.paginacao, pagina: pagina } },
      () => {
        this.load();
      }
    );
  }

  async handleClickDeletar() {
    await axios
      .delete(
        `${this.props.getBaseUrlApi()}/usuarios/${this.state.idSelecionado}`,
        this.props.parameters()
      )
      .then((response) => {
        this.toggleModal();
        this.notificar("success", "Usuário deletado com sucesso!");
        this.load();
      })
      .catch((error) => {
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status === 401) {
            this.props.logout();
          }
          if (error.response.status === 403) {
            this.props.history.push("/home");
          }
        }
      });
  }

  toggleModalDeslogar() {
    this.setState({ modalDeslogar: !this.state.modalDeslogar });
  }

  handleClickDeslogar(id) {
    this.setState({ idUsuarioDeslogar: id }, () => {
      this.toggleModalDeslogar();
    });
  }

  async handleConfirmDeslogar() {
    await axios
      .post(
        `${this.props.getBaseUrlApi()}/usuarios/deslogar`,
        { id: this.state.idUsuarioDeslogar },
        this.props.parameters()
      )
      .then((response) => {
        this.toggleModalDeslogar();
        this.notificar("success", "Usuário deslogado com sucesso!");
        this.load();
      })
      .catch((error) => {
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status === 401) {
            this.props.logout();
          }
          if (error.response.status === 403) {
            this.props.history.push("/home");
          }
        }
      });
  }

  abrirPaginaEditar(id){
    this.props.history.push(`/usuarios-novo?id=${id}`)
  }

  render() {
    return (
      <React.Fragment>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnVisibilityChange
          draggable
          pauseOnHover
        />
        <div className="container-scroller font-app">
          <NavBar title="Usuários" />
          <div className="container-fluid page-body-wrapper">
            <SideBar itemActive={"usuarios"} />
            <div className="main-panel">
              <div className="content-wrapper">
                <div className="row font-size-13">
                  <div className="col-md-12 grid-margin stretch-card">
                    <div className="card">
                      <div className="card-body dashboard-tabs p-0">
                        <div
                          style={{
                            padding: "15px 15px",
                            width: "100%",
                            textAlign: "right",
                          }}
                        >
                          Utilizado {this.state.totalLicencasUtilizadas} de{" "}
                          {this.state.totalLicencas} licenças
                        </div>
                        <div className="tab-content py-0 px-0">
                          <div
                            className="tab-pane fade show active"
                            id="overview"
                            role="tabpanel"
                            aria-labelledby="overview-tab"
                          >
                            <div className="d-flex flex-wrap justify-content-xl-between">
                              <div
                                style={{
                                  padding: "0 15px",
                                  float: "left",
                                  width: "100%",
                                }}
                              >
                                <div
                                  style={{
                                    float: "left",
                                    width: "100%",
                                    backgroundColor: "#fafbfc",
                                  }}
                                >
                                  <table
                                    className="table table-hover table-striped"
                                    style={{ fontSize: "15px" }}
                                  >
                                    <thead className="thead-dark">
                                      <tr>
                                        <th style={{}}>Descrição</th>
                                        <th>Login</th>
                                        <th>Cargo</th>
                                        <th>Logado ?</th>
                                        <th className="text-center">
                                          Data ativação
                                        </th>
                                        <th className="text-center">Ações</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {this.state.usuarios.map(
                                        (usuario, key) => (
                                          <tr key={key}>
                                            <td>{usuario.desc}</td>
                                            <td>{usuario.login}</td>
                                            <td>{usuario.cargo}</td>
                                            <td>
                                              {usuario.licencaWeb === null
                                                ? "Não"
                                                : "Sim"}
                                            </td>
                                            <td className="text-center">
                                              {usuario.licencaWeb === null
                                                ? "-"
                                                : moment(
                                                    usuario.licencaWeb
                                                      .dtCadastro
                                                  ).format("DD/MM/YYYY HH:mm")}
                                            </td>

                                            <td>
                                              <div
                                                className="d-flex"
                                                style={{
                                                  justifyContent: "center",
                                                }}
                                              >
                                                <div
                                                  onClick={() =>
                                                    this.setState(
                                                      {
                                                        idSelecionado:
                                                          usuario._id,
                                                      },
                                                      () => {
                                                        this.toggleModal();
                                                      }
                                                    )
                                                  }
                                                  style={{ margin: "5px" }}
                                                >
                                                  <i
                                                    id={`excluir-usuario-${usuario._id}`}
                                                    className="fa fa-times"
                                                    style={{
                                                      fontSize: "18px",
                                                      color: "red",
                                                      cursor: "pointer",
                                                    }}
                                                  ></i>

                                                  <UncontrolledTooltip
                                                    placement="right"
                                                    target={`excluir-usuario-${usuario._id}`}
                                                  >
                                                    Excluir Usuário
                                                  </UncontrolledTooltip>
                                                </div>
                                                <div
                                                  onClick={() => this.abrirPaginaEditar(usuario._id) }
                                                  style={{ margin: "5px" }}
                                                >
                                                  <i
                                                    id={`editar-usuario-${usuario._id}`}
                                                    className="fa fa-pencil"
                                                    style={{
                                                      fontSize: "18px",
                                                      color: "blue",
                                                      cursor: "pointer",
                                                    }}
                                                  ></i>

                                                  <UncontrolledTooltip
                                                    placement="right"
                                                    target={`editar-usuario-${usuario._id}`}
                                                  >
                                                    Editar Usuário
                                                  </UncontrolledTooltip>
                                                </div>
                                                <div
                                                  onClick={() =>
                                                    this.handleClickDeslogar(
                                                      usuario._id
                                                    )
                                                  }
                                                  style={{ margin: "5px" }}
                                                  disabled={
                                                    usuario.licencaWeb === null
                                                      ? true
                                                      : false
                                                  }
                                                >
                                                  <i
                                                    id={`deslogar-usuario-${usuario._id}`}
                                                    className="fa fa-power-off"
                                                    style={{
                                                      fontSize: "18px",
                                                      color: "#efa214",
                                                      cursor: "pointer",
                                                    }}
                                                  ></i>

                                                  <UncontrolledTooltip
                                                    placement="right"
                                                    target={`deslogar-usuario-${usuario._id}`}
                                                  >
                                                    Deslogar Usuário
                                                  </UncontrolledTooltip>
                                                </div>
                                                <div
                                                  onClick={() =>
                                                    this.props.history.push(`/usuarios-meta?id=${usuario._id}`)
                                                  }
                                                  style={{ margin: "5px" }}
                                                  
                                                >
                                                  <i
                                                    id={`meta-usuario-${usuario._id}`}
                                                    className="fa fa-line-chart"
                                                    style={{
                                                      fontSize: "18px",
                                                      color: "green",
                                                      cursor: "pointer",
                                                    }}
                                                  ></i>

                                                  <UncontrolledTooltip
                                                    placement="right"
                                                    target={`meta-usuario-${usuario._id}`}
                                                  >
                                                    Meta do Usuário
                                                  </UncontrolledTooltip>
                                                </div>
                                              </div>
                                            </td>
                                          </tr>
                                        )
                                      )}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <Footer />
            </div>
          </div>
        </div>

        <Modal isOpen={this.state.modal} toggle={this.toggleModal}>
          <ModalHeader toggle={this.toggleModal}>Inativar Usuário</ModalHeader>
          <ModalBody>Tem certeza que deseja inativar este usuário?</ModalBody>
          <ModalFooter>
            <Button color="danger" onClick={this.handleClickDeletar}>
              Inativar
            </Button>{" "}
            <Button color="secondary" onClick={this.toggleModal}>
              Cancelar
            </Button>
          </ModalFooter>
        </Modal>

        <Modal
          isOpen={this.state.modalDeslogar}
          toggle={this.toggleModalDeslogar}
        >
          <ModalHeader toggle={this.toggleModalDeslogar}>
            Deslogar usuário
          </ModalHeader>
          <ModalBody>Tem certeza que deseja deslogar este usuário?</ModalBody>
          <ModalFooter>
            <Button color="danger" onClick={this.handleConfirmDeslogar}>
              Sim
            </Button>{" "}
            <Button color="secondary" onClick={this.toggleModalDeslogar}>
              Cancelar
            </Button>
          </ModalFooter>
        </Modal>
      </React.Fragment>
    );
  }
}
